import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import Loader from 'shared/components/Loader/Loader';
import * as s from './../UIStyle.css';

const ButtonGeneral = ({
  text,
  type,
  theme,
  clickHandler,
  Icon,
  className,
  isProcessing,
  disabled,
  userTranslate,
  iconAfterText,
  ...inputParams
}) => (
  <button
    disabled={disabled || isProcessing}
    className={cx(s.ButtonGeneral, {
      [s.ButtonTransparent]: theme === 'Transparent',
      [s.ButtonTransparentYellow]: theme === 'TransparentYellow',
      [s.ButtonYellow]: theme === 'Yellow',
      [s.ButtonWhite]: theme === 'White',
      [s.ButtonYellowFlat]: theme === 'YellowFlat',
      [s.ButtonDisabledStyle]: theme === 'DisabledStyle',
      [s.ButtonProcessing]: isProcessing,
      [className]: !!className,
      [s.iconAfterText]: iconAfterText,
    })}
    type={type}
    onClick={clickHandler}
    {...inputParams}
  >
    <Loader isLoading={isProcessing} className={s.ButtonLoader} />
    {Icon && !iconAfterText ? <Icon /> : null}
    {userTranslate ? <FormattedMessage id={text} /> : text}
    {Icon && iconAfterText ? <Icon /> : null}
  </button>
);

ButtonGeneral.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string,
  Icon: PropTypes.func,
  clickHandler: PropTypes.func,
  isProcessing: PropTypes.bool,
  disabled: PropTypes.bool,
  userTranslate: PropTypes.bool,
  iconAfterText: PropTypes.bool,
};

ButtonGeneral.defaultProps = {
  type: 'submit',
  theme: 'Yellow',
  className: '',
  Icon: null,
  disabled: false,
  clickHandler: () => {},
  isProcessing: false,
  userTranslate: true,
  iconAfterText: false,
};

export default withStyles(s)(ButtonGeneral);



// WEBPACK FOOTER //
// ./src/shared/components/UI/Button/Button.js